import { axiosInstance } from 'shared/api';
import { getCashdeskUrl } from 'shared/api/config/api.config';

import { TCashdesk } from './types/cashdesk.types';

export const CashdesksService = {
  async getCashdesks() {
    const response = await axiosInstance.get<TCashdesk.GetMethodsSuccess>(
      getCashdeskUrl('/get-cashdesk')
    );

    return response;
  }
};
